import { useState } from 'react';
import { SearchBar, SpacingLargeTop } from '@mews-commander/ui';
import { WithGroupId } from '@mews-commander/types';
import { Container, Stack, StackItem, Virtualizer } from '@optimus-web/core';
import { ScopeProvider } from '@mews/framework';
import { getUrlParameter, useCommanderSelector } from '@mews-commander/utils';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getReservationIdsByGroupId } from '@mews-commander/legacy-entities/src/ducks';
import BillingGroupingSelect from '../components/BillingGroupingSelect';
import { CustomerCard } from '../CustomerCard/CustomerCard';
import { ExpandCollapseAll } from '../ExpandCollapseAll';
import { GroupItemAssignmentDialog } from '../ItemAssignmentDialog';
import { getAccountsData, getOrderedAccountIds } from '../selectors';
import { TopToolbar } from '../TopToolbar';
import { useFilteredAccounts } from './useFilteredAccounts';

export const GroupBilling = ({ groupId }: WithGroupId) => {
    const scope = groupId;
    const accountIdParam = getUrlParameter('accountId') as string;
    const [search, setSearch] = useState('');

    const enterpriseId = useCurrentEnterpriseId();
    const serviceOrderIds = useCommanderSelector((state) =>
        getReservationIdsByGroupId(state, { groupId, enterpriseId })
    );

    const { accountsFullNames, accountsAllBillIds } = useCommanderSelector((state) =>
        // @ts-expect-error
        getAccountsData(state, { scope, serviceOrderIds })
    );

    // @ts-expect-error
    const accountIds = useCommanderSelector((state) => getOrderedAccountIds(state, { scope, serviceOrderIds }));

    const filteredAccountIds = useFilteredAccounts({
        accountIds,
        groupId,
        search,
    });
    let focusedAccountIndex = accountIdParam ? filteredAccountIds.indexOf(accountIdParam) : undefined;
    focusedAccountIndex = focusedAccountIndex === -1 ? undefined : focusedAccountIndex;

    const customerCards = filteredAccountIds.map((accountId) => (
        <Container padding="300" key={accountId}>
            <CustomerCard
                key={accountId}
                accountId={accountId}
                billIds={accountsAllBillIds[accountId] ?? []}
                fullName={accountsFullNames[accountId] ?? ''}
            />
            <Container padding={['700', '0']} />
        </Container>
    ));

    return (
        <ScopeProvider value={scope}>
            <Stack vertical fill>
                <Container padding={['0', '300']}>
                    <SpacingLargeTop />
                    <Stack distribution="space-between">
                        <StackItem width="220px">
                            <BillingGroupingSelect scope={scope} />
                        </StackItem>
                        <Stack>
                            <SearchBar onSearchChange={setSearch} defaultSearch={search} />
                            <ExpandCollapseAll />
                        </Stack>
                    </Stack>
                    <SpacingLargeTop />
                    <TopToolbar />
                </Container>
                <Virtualizer estimatedSize={150} items={customerCards} scrollToIndex={focusedAccountIndex} />
            </Stack>
            <GroupItemAssignmentDialog serviceOrderIds={serviceOrderIds} />
        </ScopeProvider>
    );
};
